import axios from "axios"

class MyNotes {
  constructor() {
    if (document.querySelector("#my-notes")) {
      this.number = document.querySelector("#add-number")
      this.integer = 3;
      this.events()
    }
  }

  events() {
    document.querySelector(".submit-note").addEventListener("click", () => this.createNote())
  }

  findNearestParentLi(el) {
    let thisNote = el
    while (thisNote.tagName != "LI") {
      thisNote = thisNote.parentElement
    }
    return thisNote
  }

  convertToDateThai( date) {
    let result = date.getDate()
    return result; 
  }

  async createNote() {
    var ourNewPost = {
      "title": document.querySelector(".new-note-title").value,
      "content": document.querySelector(".new-note-body").value,
      "status": "publish"
    }
    
    
    // const date = new Date(2020, 7, 1)
    const date = new Date()
    var mYear = date.getFullYear();
    var mdays = date.getDate();
    const mMonth = date.toLocaleDateString('th-TH', { month: 'long' })
    const time = date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

    // const result = date.toLocaleDateString('th-TH', {
    //   year: 'numeric',
    //   month: 'long',
    //   day: 'numeric',
    //   weekday: 'long',
    // })

    var dateresult = `${mMonth} ${mdays}  , ${mYear}`;
    try {

      if (ourNewPost.title != "") {
        this.integer += 1;
        this.number.innerHTML = this.integer;   
        document.querySelector(".new-note-title").value = ""
        document.querySelector(".new-note-body").value = ""
        document.querySelector("#my-notes").insertAdjacentHTML(
          "afterbegin",
          `<li>
              <div class="gb-entry gb-entry_4 gb-entry-count_1 gwolle_gb_uneven gwolle-gb-uneven gwolle_gb_first gwolle-gb-first">
                  <div class="gb-author-info">
                      <span class="gb-author-avatar"><img referrerpolicy="no-referrer" alt="จิณณิชวัรชญ์" src="https://secure.gravatar.com/avatar/04762635567fa928c6f5dbc854d7f3df?s=32&amp;d=mm&amp;r=g" srcset="https://secure.gravatar.com/avatar/04762635567fa928c6f5dbc854d7f3df?s=64&amp;d=mm&amp;r=g 2x" class="avatar avatar-32 photo" width="32" height="32"></span>
                      <span class="gb-author-name"><i class="gb-moderator">${ourNewPost.title}</i></span>
                      <span class="gb-datetime">
                          <span class="gb-date">
                              <span class="gb-date-wrote-text"> wrote on</span>
                              <span class="gb-date-text">${dateresult}</span>
                          </span>
                          <span class="gb-time">
                              <span class="gb-time-at-text"> at</span>
                              <span class="gb-time-text">${time}</span>
                          </span>
                      </span>
                  </div>
                  <div class="gb-entry-content">${ourNewPost.content}</div>
              </div>
            </li>`
          )
  

        // notice in the above HTML for the new <li> I gave it a class of fade-in-calc which will make it invisible temporarily so we can count its natural height

        let finalHeight // browser needs a specific height to transition to, you can't transition to 'auto' height
        let newlyCreated = document.querySelector("#my-notes li")

        // give the browser 30 milliseconds to have the invisible element added to the DOM before moving on
        setTimeout(function () {
          finalHeight = `${newlyCreated.offsetHeight}px`
          newlyCreated.style.height = "0px"
        }, 30)

        // give the browser another 20 milliseconds to count the height of the invisible element before moving on
        setTimeout(function () {
          newlyCreated.classList.remove("fade-in-calc")
          newlyCreated.style.height = finalHeight
        }, 50)

        // wait the duration of the CSS transition before removing the hardcoded calculated height from the element so that our design is responsive once again
        setTimeout(function () {
          newlyCreated.style.removeProperty("height")
        }, 450)
      } else {
        alert('ตรวจสอบข้อความใหม่อีกครั้ง.!')
      }
    } catch (e) {
      console.error(e)
    }
  }
}

export default MyNotes
